<template>
  <div class="row">
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="col-md-12">
      <div class="page-title-box">
        <div class="float-right">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);">Chart of Account</a>
            </li>
            <li class="breadcrumb-item active">List</li>
          </ol>
        </div>
        <h4 class="page-title">Chart Of Account</h4>
      </div>
      <div class="card">
          <div class="card-body">
            <ul class="nav nav-tabs nav-bordered">
              <li class="nav-item"><a href="#coa-tab" data-toggle="tab" aria-expanded="false" class="nav-link active">Sales</a></li>
              <li class="nav-item"><a href="#saldo-tab" data-toggle="tab" aria-expanded="false" class="nav-link">Account Saldo</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="coa-tab">
                <div class="form-inline">
                  <div class="button-group">
                    <select v-model="company" class="btn btn-soft-outline-primary btn-sm mr-1">
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                    <button type="button" class="btn btn-outline-primary btn-sm" data-toggle="tooltip" data-placement="top" title="Create New Account" @click="addAccount">
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-outline-primary btn-sm" data-toggle="tooltip" data-placement="top" title="Create New Account Type" @click="addAccountType">
                      <i class="fa fa-plus" aria-hidden="true"></i>Type
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="top" title="Refresh" @click="refreshAccount">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-item mb-0 table-sm table-hover">
                    <thead>
                        <tr>
                            <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll">
                                <i class="form-icon"></i>
                              </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr  v-for="d in filterData" :key="d.id" @click="editData(d.id, d.hierarcy)" style="cursor: pointer">
                            <td>
                            <label class="form-checkbox">
                                <input type="checkbox" :value="d.id" v-model="selected">
                                <i class="form-icon"></i>
                                </label>
                            </td>
                            <td>
                                <span v-if="d.hierarcy == 1"><b>{{ d.code }} {{ d.name }}</b></span>
                                <span v-else-if="d.hierarcy == 2" class="ml-3"><b>{{ d.code }} - {{ d.name }}</b></span>
                                <span v-else class="ml-5">{{ d.code }} {{ d.name }}</span>
                            </td>
                            <td>
                              <span v-if="d.active === true"><i class="fa fa-check" style="color: green;"></i></span>
                            </td>
                            <td>{{ d.account_balance }}</td>
                            <td>{{ d.method }}</td>
                            <td>{{ d.group }}</td>
                            <td>{{ d.calculate }}</td>
                            <td>{{ d.saldo }}</td>
                        </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="tab-pane" id="saldo-tab">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="form-inline">
                      <div class="button-group">
                        <select v-model="company" class="btn btn-soft-outline-primary btn-sm mr-1">
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                        <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        <button type="button" class="btn btn-soft-primary btn-sm ml-1" data-toggle="tooltip" data-placement="top" title="Refresh" @click="refreshSaldo"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-hard-primary btn-sm ml-1" @click="setModal">Set Modal</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5>Fix Asset - {{ totalFixAssetSaldo | currency }}</h5>
                    <div class="table-responsive">
                      <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                          <th>No.</th>
                          <th>Account</th>
                          <th>Date</th>
                          <th class="text-right">Saldo</th>
                        </thead>
                        <tbody>
                          <tr v-for="(f, idx) in fixAssetSaldo" :key="idx">
                            <td>{{ idx + 1 }}</td>
                            <td>{{ f.account_code }} {{ f.account }} - {{ f.product_no }}</td>
                            <td>{{ f.saldo_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td class="text-right">{{ f.saldo | currency }}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td></td>
                            <td></td>
                            <td>Total</td>
                            <td class="text-right">{{ totalFixAssetSaldo | currency }}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5>Equity</h5>
                    <div class="table-responsive">
                      <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                          <th>Account</th>
                          <th>Date</th>
                          <th class="text-right">Saldo</th>
                        </thead>
                        <tbody>
                          <tr v-for="f in equitySaldo" :key="f.id">
                            <td>{{ f.account_code }} {{ f.account }}</td>
                            <td>{{ f.saldo_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td class="text-right">{{ f.saldo | currency }}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td></td>
                            <td><b>Total Modal</b></td>
                            <td class="text-right"><b>{{ totalEquitySaldoModal | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td><b>Total Laba Rugi</b></td>
                            <td class="text-right"><b>{{ totalEquitySaldoLabaRugi | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td><b>Total</b></td>
                            <td class="text-right"><b>{{ totalEquitySaldo | currency }}</b></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <!-- <pre>{{ filterData }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { accountUrl, chartOfAccountUrl, getHeader } from '../../config'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'InventoryList',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      company: null,
      dataRaw: [],
      dataRawSaldo: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Account Code',
        prop: 'account_code'
      }, {
        name: 'Active',
        prop: 'active'
      }, {
        name: 'Balance',
        prop: 'account_balance'
      }, {
        name: 'Method',
        prop: 'method'
      }, {
        name: 'Group',
        prop: 'group_id'
      }, {
        name: 'Calculate',
        prop: 'calculate'
      }, {
        name: 'Saldo',
        prop: 'saldo'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    var authUser = JSON.parse(window.localStorage.getItem('authUser'))
    this.company = authUser.user.company_no
    this.refreshAccount()
  },
  methods: {
    async setModal () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var cid = null
      if (this.company === 'C0001') {
        cid = '01'
      } else {
        cid = '11'
      }
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      // const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var body = {
        account_code: cid + '-310-001',
        saldo: this.totalFixAssetSaldo,
        saldo_date: begin,
        method: 'debet',
        product_no: null,
        term: 'replace'
      }
      console.log(body)
      console.log(accountUrl + '/saldo')
      await axios.post(accountUrl + '/saldo', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Account Saldo', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Account Saldo', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.refreshSaldo()
    },
    async editData (id) {
      var data = this.dataRaw.find(d => d.id === id)
      if (data.hierarcy === 3) {
        this.$emit('editAccount', data)
      } else {
        this.$emit('editAccountType', data)
      }
    },
    addAccount () {
      this.$emit('newAccount')
    },
    addAccountType () {
      this.$emit('newAccountType')
    },
    refreshAccount () {
      this.$Progress.start()
      this.loader.isLoading = true
      console.log(chartOfAccountUrl + '?company=' + this.company)
      axios.get(chartOfAccountUrl + '?company=' + this.company, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
          this.$store.commit('SET_CHART_OF_ACCOUNT_LIST', response.data.data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async refreshSaldo () {
      await this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var body = {
        begin: begin,
        end: end,
        company_no: this.company
      }
      console.log(body)
      await axios.post(accountUrl + '/get-account-saldo', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRawSaldo = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Account Saldo', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList
    }),
    fixAssetSaldo () {
      var array = this.dataRawSaldo.filter(d => d.group_id === 'neraca').filter(d => d.account_balance === 'fixasset')
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i].id,
          account_code: array[i].account_code,
          account: array[i].account,
          saldo: array[i].saldo,
          saldo_date: array[i].saldo_date,
          method: array[i].method,
          product_no: array[i].product_no,
          group_id: array[i].group_id,
          account_balance: array[i].account_balance
        }
        loop.push(obj)
      }
      return loop
    },
    totalFixAssetSaldo () {
      var sum = 0
      var array = this.fixAssetSaldo
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldo)
      }
      return sum
    },
    equitySaldo () {
      var array = this.dataRawSaldo.filter(d => d.group_id === 'neraca').filter(d => d.account_balance === 'equity')
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i].id,
          account_code: array[i].account_code,
          account: array[i].account,
          saldo: array[i].saldo,
          saldo_date: array[i].saldo_date,
          method: array[i].method,
          product_no: array[i].product_no,
          group_id: array[i].group_id,
          account_balance: array[i].account_balance
        }
        loop.push(obj)
      }
      return loop
    },
    totalEquitySaldo () {
      var sum = 0
      var array = this.equitySaldo
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldo)
      }
      return sum
    },
    totalEquitySaldoModal () {
      let cid = null
      if (this.company === 'C0001') {
        cid = '01'
      } else {
        cid = '11'
      }
      var sum = 0
      const modalAccount = cid + '-310-001'
      console.log(modalAccount)
      var array = this.equitySaldo.filter(d => d.account_code === modalAccount)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldo)
      }
      return sum
    },
    totalEquitySaldoLabaRugi () {
      let cid = null
      if (this.company === 'C0001') {
        cid = '01'
      } else {
        cid = '11'
      }
      var sum = 0
      const account = cid + '-320-002'
      console.log(account)
      var array = this.equitySaldo.filter(d => d.account_code === account)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldo)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      // var col = this.sortColumn
      // var ascending = this.ascending
      return this.dataRaw.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    }
  }
}
</script>

<style>
.scroll{
    max-height: 540px;
    overflow-y: auto;
}
</style>
